<template>
  <div id="mngmnt-page">
    <div class="row no-margin-bottom switch-page-spacing" style="margin-top: 5px">
      <div class="col">
        <div class="breadcrumb-div">
          <span class="breadcrumb-link" ref="region-link" @click="navigateToList" >{{ $t('management.users') }}</span>
        </div>
        <div v-if="selectedUser !== null" class="breadcrumb-div breadcrumb-link">&nbsp;/&nbsp;</div>
        <div v-if="selectedUser !== null" class="breadcrumb-div">
          <span class="breadcrumb-link" ref="dept-link">{{ selectedUserName }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <div class="row">
          <div class="col s10">
            <div class="z-depth-1 white">
              <div v-if="authorized" class="content">
                <Component v-bind:is="selectedComponent" :locales="this.locales" :model="selectedUser" :cancel-fn="navigateToList"/>
              </div>
              <div v-else>
                <Home :message="$t('management.norights')" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserList from '../../components/usermanagement/users/UserList'
import UserEdit from '../../components/usermanagement/users/UserEdit'
import AuthenticationService from '../../services/AuthenticationService'
import router from '../../router'
import Home from '../../components/usermanagement/Home'
import usersApi from '../../services/api/UsersApi'
import languageService from '../../services/api/LanguageService'

export default {
  name: 'UserManagement',
  components: {
    Home,
    UserList,
    UserEdit
  },
  props: {},
  data () {
    return {
      selectedUser: null,
      selectedComponent: 'UserList',
      locales: [],
      authorized: false
    }
  },
  computed: {
    selectedUserName () {
      return `${this.selectedUser.FirstName} ${this.selectedUser.MiddleName ? this.selectedUser.MiddleName : ''} ${this.selectedUser.LastName}`
    }
  },
  watch: {
    $route (to, from) {
      this.setAuthorization()
      this.showComponent()
    },
    breadCrumbRailObjectId (val) {
      this.changeRailObject(val)
    }
  },
  mounted () {
    this.getLocales()
    this.setAuthorization()
    this.showComponent()
  },
  methods: {
    setAuthorization () {
      const user = AuthenticationService.getUser()
      let routeUserId = parseInt(router.currentRoute.params['id'])
      this.authorized = user.SystemRoleId >= 2 || (routeUserId && user.UserId === routeUserId)
    },
    showComponent () {
      if (router.currentRoute.params['id']) {
        const id = router.currentRoute.params['id']
        usersApi.getUser(id)
          .then(result => {
            const user = result.data
            this.selectedUser = user
            if (this.selectedUser === null) {
              this.selectedComponent = 'Home'
            } else {
              this.selectedComponent = 'UserEdit'
            }
          })
      } else {
        this.selectedUser = null
        this.selectedComponent = 'UserList'
      }
    },
    navigateToList () {
      router.push('/users')
    },
    navigateTab (component) {
      this.selectedComponent = component
    },
    getLocales () {
      languageService.getLanguages().then(response => {
        response.data.forEach(element => {
          this.locales.push(element.Translation)
        })
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
  .tab-bar > div {
    height: 40px;
    padding-left: 25px;
    cursor: pointer;
  }
  .tab-bar > .selected {
    background-color: #2196F3;
    color: white;
  }
  #mngmnt-page {
    width: 100%;
    height: calc(100vh - 56px);
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .selected {
    background-color: #2196F3;
    color: white;
  }

  .content {
    margin: 0.5rem 0 0.5rem 0;
  }

  .breadcrumb-div {
    display: inline-block;
  }
  .breadcrumb-link {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0,0,0, .56);
    cursor: pointer;
  }
  .breadcrumb-link-main {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0, 0, 0, 0.87);
    /* cursor: pointer; */
  }
  .inner-breadcrumb-content {
    max-height: 300px;
    width: 345px;
    overflow-y: auto;
    background-color: white;
    /* border: 1px solid  rgba(0, 0, 0, 0.56); */
    font-family: Roboto;
  }
  .breadcrumb-table {
    position: relative;
  }
  .breadcrumb-table thead tr {
    border-top: 1px solid rgba(0, 0, 0, 0.4);
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  }
  .breadcrumb-table th, .breadcrumb-table td {
    padding: 5px 5px;
  }
  .inner-content {
    position: fixed;
    z-index: 4;
  }
  .slide-fade-enter-active {
    transition: all .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s ease;
  }
  .slide-fade-enter {
    transform: translateY(-50px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/management/UserManagement.vue